import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private readonly router: Router) {
  }

  navigateToErrorPage(error: HttpErrorResponse): Promise<boolean> {
    const status = (error?.status) ? error?.status : 900;
    switch (status) {
      case 403:
      case 404:
        return this.router.navigate(['forbidden', status]);
      case 503:
        return this.router.navigate(['unavailable', status]);
      default:
        return this.router.navigate(['error', status]);
    }
  }
}
